/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* @typescript-eslint/no-unsafe-assignment */
import { AutoSaveProvider, IAutoSaveProvider } from '@pwc/auto-save-ui';
import { LockHttpClient } from 'common/services/httpClient';
import userTokenService from 'common/services/security/userTokenService';
import featureFlags from 'common/helpers/featureFlags';
import { ReactNode } from 'react';

interface IAutoSaveProps extends IAutoSaveProvider {
  disableAutoSaveOverride: boolean;
  enableAutoLockContext: boolean;
  children: ReactNode;
}

const AutoSave = ({
  disableAutoSaveOverride,
  enableAutoLockContext,
  projectId,
  children,
  ...rest
}: IAutoSaveProps) => {
  const isReadOnly = userTokenService.isPwcReadOnlyRole(projectId);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  const userId = userTokenService.getUserId() as number;
  const enableAutoSave =
    !isReadOnly && featureFlags.isAutoSaveEnabled && !disableAutoSaveOverride;

  return (
    <AutoSaveProvider
      projectId={Number(projectId)}
      {...rest}
      config={{
        enabled: enableAutoSave,
        enableAutoLockContext,
        httpClient: LockHttpClient(projectId),
        autoSaveTimerIntervalDelay: Number(
          process.env.REACT_APP_AUTO_SAVE_DELAY
        ),
        maxAutoSaveIdleTime: Number(process.env.REACT_APP_AUTO_SAVE_IDLE_TIME),
        autoLockTimerIntervalDelay: Number(
          process.env.REACT_APP_AUTO_LOCK_DELAY
        ),
      }}
      isDev={featureFlags.isAutoSaveDevMode}
      currentUserId={Number(userId)}
    >
      {children}
    </AutoSaveProvider>
  );
};

export default AutoSave;
